import _ from 'lodash'

import { FormValueSelector, FormMetaSelector } from '../../../../Common/forms'
import withCurrentSubStation from '../../HOC/withCurrentSubStation'
import { PRODUCT_SIZE_KEYS } from '../../../../../constants/proposalTypes'
import { showOnlyNumber } from '../../../../../lib/formatter'
import { ProductInfo } from './ProductInfo'
import { getScopedFieldNameByShipType } from '../Shared/util'
import { PRODUCT_SHIP_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'

/** scopedProdcut metaObject 中的長寬高重量是否有 visited */
const isAnyVisited = scopedProductMeta => {
  return _.some(_.pick(scopedProductMeta, PRODUCT_SIZE_KEYS), o => _.get(o, 'visited', false))
}
const ProductInfoComp = (props) => (
  <FormValueSelector fieldName='product.shipType.id'>
    {
      shipType => {
        const scopedProductFieldName = getScopedFieldNameByShipType(shipType || PRODUCT_SHIP_TYPE.EXPRESS_24HR, 'product')
        return (
          <FormMetaSelector fieldName={scopedProductFieldName}>
            {scopedProductMeta => {
              const anySizeVisited = isAnyVisited(scopedProductMeta)
              return (
                <FormValueSelector
                  selector={select => ({
                    readOnly: select('setting.readOnly'),
                    showExpiringAddon: select('setting.showExpiringAddon'),
                    scopedProduct: select(scopedProductFieldName)
                  })}
                >
                  {
                    values => {
                      const {
                        readOnly = false,
                        scopedProduct = {},
                        showExpiringAddon
                      } = values

                      const { isExpiringItem = false } = scopedProduct

                      const productSize = PRODUCT_SIZE_KEYS.reduce(
                        (acc, cur) => {
                          const oneDimensionValue = scopedProduct[cur] || 0
                          acc[cur] = showOnlyNumber(oneDimensionValue)
                          return acc
                        }, {})

                      return (
                        <ProductInfo
                          {...props}
                          {...productSize}
                          isExpiringItem={isExpiringItem}
                          readOnly={readOnly}
                          anySizeVisited={anySizeVisited}
                          showExpiringAddon={showExpiringAddon}
                        />
                      )
                    }}
                </FormValueSelector>
              )
            }}
          </FormMetaSelector>
        )
      }
    }
  </FormValueSelector>
)

const ProductInfoContainer = withCurrentSubStation(ProductInfoComp)

export default ProductInfoContainer
